{
  "name": "b-n-mosoda-angular-kliens",
  "version": "1.9.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "test": "ng test",
    "lint": "ng lint",
    "prod-build": "ng build -c production",
    "demo-build": "ng build -c production --source-map=true",
    "e2e": "playwright test",
    "e2e:headed": "playwright test --headed",
    "e2e:report": "playwright show-report"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.19",
    "@angular/cdk": "20.2.14",
    "@angular/common": "^20.3.19",
    "@angular/compiler": "^20.3.19",
    "@angular/core": "^20.3.19",
    "@angular/forms": "^20.3.19",
    "@angular/material": "20.2.14",
    "@angular/platform-browser": "^20.3.19",
    "@angular/platform-browser-dynamic": "^20.3.19",
    "@angular/router": "^20.3.19",
    "@fontsource/inter": "^5.2.8",
    "@innobile/authmodule": "^3.1.4",
    "@stomp/rx-stomp": "^2.0.1",
    "@stomp/stompjs": "^7.0.0",
    "@typescript-eslint/types": "^8.33.1",
    "@typescript-eslint/utils": "^8.33.1",
    "leaflet": "^1.9.4",
    "luxon": "^3.5.0",
    "material-icons": "^1.13.12",
    "material-symbols": "^0.27.0",
    "rxjs": "~7.8.0",
    "tippy.js": "^6.3.7",
    "tslib": "^2.8.1",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^20.3.25",
    "@angular-eslint/builder": "20.7.0",
    "@angular-eslint/eslint-plugin": "20.7.0",
    "@angular-eslint/eslint-plugin-template": "20.7.0",
    "@angular-eslint/schematics": "20.7.0",
    "@angular-eslint/template-parser": "20.7.0",
    "@angular/cli": "^20.3.25",
    "@angular/compiler-cli": "^20.3.19",
    "@playwright/mcp": "^0.0.82",
    "@playwright/test": "^1.63.0",
    "@types/jasmine": "~5.1.0",
    "@types/leaflet": "^1.9.14",
    "@types/lodash": "^4.17.0",
    "@types/luxon": "^3.4.2",
    "@types/node": "^22.0.0",
    "@typescript-eslint/eslint-plugin": "^8.33.1",
    "@typescript-eslint/parser": "^8.33.1",
    "eslint": "^9.28.0",
    "jasmine-core": "~5.4.0",
    "jasmine-spec-reporter": "~7.0.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "prettier": "^3.8.3",
    "ts-node": "~10.9.0",
    "typescript": "~5.9.3"
  },
  "packageManager": "yarn@3.3.0"
}
